<script setup>
import { computed, ref, watch } from 'vue';
import { useFilesHandler } from '../../../composables/filesHandler';
import FilesTable from '../../files/FilesTable.vue';
import DropArea from '../../utils/DropArea.vue';

const ATTACHMENT_5_INPUT_ID = 'attachment5InputField';
const ATTACHMENT_6_INPUT_ID = 'attachment6InputField';

const attachment5FilesHandler = useFilesHandler(false, ATTACHMENT_5_INPUT_ID);
const attachment6FilesHandler = useFilesHandler(false, ATTACHMENT_6_INPUT_ID);

const attachment5FilesTable = ref([]);
const attachment6FilesTable = ref([]);

const showAttachment5Input = computed(() => attachment5FilesTable.value.length === 0);
const showAttachment6Input = computed(() => attachment6FilesTable.value.length === 0);

const bothAttachmentsUploaded = computed(() => {
  return attachment5FilesTable.value.length > 0 && attachment6FilesTable.value.length > 0;
});

const attachment5 = computed(() => {
  return attachment5FilesTable.value.length > 0 ? attachment5FilesTable.value[0].file : null;
});

const attachment6 = computed(() => {
  return attachment6FilesTable.value.length > 0 ? attachment6FilesTable.value[0].file : null;
});

watch(attachment5FilesHandler.filesRef, () => {
  recomputeAttachment5Files();
});

function recomputeAttachment5Files() {
  attachment5FilesTable.value = attachment5FilesTable.value.concat(
    attachment5FilesHandler.filesRef.value
  );

  for (let i = 0; i < attachment5FilesTable.value.length; i++) {
    attachment5FilesTable.value[i].id = i;
  }
}

watch(attachment6FilesHandler.filesRef, () => {
  recomputeAttachment6Files();
});

function recomputeAttachment6Files() {
  attachment6FilesTable.value = attachment6FilesTable.value.concat(
    attachment6FilesHandler.filesRef.value
  );

  for (let i = 0; i < attachment6FilesTable.value.length; i++) {
    attachment6FilesTable.value[i].id = i;
  }
}

function onAttachment5FileDeleted(id) {
  attachment5FilesTable.value = attachment5FilesTable.value.filter((x) => x.id !== id);
}

function onAttachment6FileDeleted(id) {
  attachment6FilesTable.value = attachment6FilesTable.value.filter((x) => x.id !== id);
}

defineExpose({ bothAttachmentsUploaded, attachment5, attachment6 });
</script>

<template>
  <div style="display: flex; flex-direction: row; gap: 20px">
    <div style="flex: 1">
      <h4>Załącznik nr 5</h4>

      <template v-if="showAttachment5Input">
        <DropArea
          id="dropAreaAttachment5"
          class="dropArea"
          caption="Upuść plik tutaj albo kliknij 'Wybierz plik' poniżej"
          :fileInputId="ATTACHMENT_5_INPUT_ID"
          @onFileChanged="attachment5FilesHandler.onDropAreaFilesChanged($event)"
        />
        <input
          :id="ATTACHMENT_5_INPUT_ID"
          name="file"
          type="file"
          class="mt-2"
          @change="attachment5FilesHandler.onFilesChanged($event)"
        />
      </template>

      <template v-else>
        <FilesTable
          :show-header="false"
          :filesArray="attachment5FilesTable"
          @fileDeleted="onAttachment5FileDeleted"
        />
      </template>
    </div>

    <div style="flex: 1">
      <h4>Załącznik nr 6</h4>

      <template v-if="showAttachment6Input">
        <DropArea
          id="dropAreaAttachment6"
          class="dropArea"
          caption="Upuść plik tutaj albo kliknij 'Wybierz plik' poniżej"
          :fileInputId="ATTACHMENT_6_INPUT_ID"
          @onFileChanged="attachment6FilesHandler.onDropAreaFilesChanged($event)"
        />
        <input
          :id="ATTACHMENT_6_INPUT_ID"
          name="file"
          type="file"
          class="mt-2"
          @change="attachment6FilesHandler.onFilesChanged($event)"
        />
      </template>

      <template v-else>
        <FilesTable
          :show-header="false"
          :filesArray="attachment6FilesTable"
          @fileDeleted="onAttachment6FileDeleted"
        />
      </template>
    </div>
  </div>
</template>

<style scoped></style>
